module.exports = __webpack_public_path__ + "img/gwyx-ebyhkxfc.e0f135ab.png";